import React, { useEffect, useRef, useState, useMemo, act } from "react";
import SubHeader from "../../../components/SubHeader";
import SiteButtons from "../../../components/SiteButtons";
import { useHref, useNavigate, useParams } from "react-router-dom";
import { URLS } from "../../../_config";
import Container from "../../../components/Container";
import { Controller, set, useForm } from "react-hook-form";
import Input from "../../../components/elements/form/input";
import CommonDropdown from "../../../components/elements/form/commonDropdown";
import Textarea from "../../../components/elements/form/textarea";
import { useLookup, getLookupDisplayValue } from "../../../_common/hookFunction";
import DatePicker from "react-datepicker";
import "react-datepicker/dist/react-datepicker.css";
import Icon from "../../../components/icons";
import moment from "moment";
import { useAppLoader } from "../../../_common/pageLoader/appLoaderHook";
import { useDiscountsApi } from "../../../store/api/hooks/discountsApiHook";
import toast from "react-hot-toast";
import TopTabs from "../../../components/topTabs";
import { useCategoriesApi } from "../../../store/api/hooks/categoriesApiHook";
import { useLocationsSelector } from "../../../store/selectors/masterSelector";
import SiteModal from "../../../components/SiteModal";
import ProductSearchModal from "../_components/ProductSearchModal";
import ProductSearchModalAll from "../_components/ProductSearchModalAll";
import Button from "../../../components/elements/button";
import ReusableTable from "../../../components/ReusableTable";
import SelectBox from "../../../components/elements/form/selectBox";
import { useCommonApi } from "../../../store/api/hooks/commonApiHook";
import {
  getRetailPriceInArray,
  getRetailPrices,
  getCashPriceDisplay,
  formatCurrency,
  formatQuantity,
  getPricingMode,
  CashDiscountConfig,
} from "../../../_common/functions";
import { useCashDiscountApi } from "../../../store/api/hooks/cashDiscountApiHook";
import SwitchSlider from "../../../components/elements/form/SwitchSlider";
import { useDialog } from "../../../store/api/hooks/dialogHook";
import { useBrandsApi } from "../../../store/api/hooks/brandsApiHook";
import { useTagsApi } from "../../../store/api/hooks/tagsApiHook";
import { useVendorsApi } from "../../../store/api/hooks/vendorsApiHook";
import { useUnitsApi } from "../../../store/api/hooks/unitsApiHook";
import { createPositiveWholeNumberHandler,createPositiveDecimalNumberHandler,getPositiveDecimalNumberInputProps } from "../../../_common/validationUtils";
import DecimalInput from "../../../components/elements/form/DecimalInput";
import { navigationConfirm } from "../../../_common/functions";
import { useTranslation } from "react-i18next";
interface Props {
  type?: any;
  discount?: any;
}
type formValues = {
  productCategory: string | null;
  productCategoryGet: string | null;
  discountId: string | null;
  fkDiscountTypeLookupValueId: string | null;
  discountName: string;
  discountDescription: string;
  isAutomatic: boolean;
  discountCode: string;
  isSetDateRange: boolean;
  isSetSchedule: boolean;
  active: boolean;
  buyProductQuantity: number;
  getProductQuantity: number;
  fkCustomerTargetTypeLookupValueId: string;
  ui_maxdiscountallowed: string | null;
  customerGroups: Array<{
    discountCustomerGroupId: string;
    fkCustomerGroupId: string;
    active: boolean;
  }>;
  locations: Array<{
    discountLocationId: string;
    fkLocationId: string;
    active: boolean;
  }>;
  products: Array<{
    discountProductId: string;
    fkProductId: string;
    fkProductVariantDetailId: string;
    fkProductRoleLookupValueId: string;
    requiredQuantity: string;
  }>;
  rules: Array<{
    discountRuleId: string;
    fkDiscountValueTypeLookupValueId: any | null;
    discountValue: string;
    fkMinimumRequirementTypeLookupValueId: string | null;
    minPurchaseAmount: string;
    minPurchaseQty: string;
    maxPurchaseQty: string | null;
    fkMaxLimitTypeLookupValueId: string | null;
    maxAllowedQty: string | null;
    maxAllowedValue: string | null;
    totalUsageLimit: any;
    limitToOneUsePerCustomer: boolean;
    requiredQuantity: string | null;
    active: boolean;
  }>;
  dateRanges: Array<{
    discountScheduleDateRangeId: string;
    startDate: any;
    endDate: any;
  }>;
  weeklySchedules: Array<{
    discountScheduleWeeklyId: string;
    dayOfWeek: string;
    startTime: any;
    endTime: any;
    isActive: boolean;
  }>;
};

const BuyXGetYDiscount: React.FC<Props> = ({ type, discount = null }) => {
  // console.log("ProductDiscount component rendered with type:", type);
  const navigate = useNavigate();
  const params = useParams();
  // console.log("URL params:", params);
  const { t, i18n } = useTranslation("discounts");
  const discountApi = useDiscountsApi();
  const cashDiscountApi = useCashDiscountApi();
  const { confirm } = useDialog();
  const [cashDiscountConfig, setCashDiscountConfig] = useState<CashDiscountConfig>(null);
  const [expandedProducts, setExpandedProducts] = useState<Set<string>>(
    new Set()
  );

  useEffect(() => {
    cashDiscountApi.getCashDiscountSettings(
      {},
      (resp: any) => {
        if (resp?.data) {
          setCashDiscountConfig({
            isCashDiscount: resp.data.cashDiscountEnabled,
            cashDiscount: resp.data.cashDiscountPercent,
            isDualPricing: resp.data.dualPricingEnabled ?? false,
            dualPriceDefault: resp.data.fkDualPriceDefaultLookupValueID ?? null,
          });
        }
      },
      () => {}
    );
  }, []);
  // const [expandedGetProducts, setExpandedGetProducts] = useState<Set<string>>(
  //   new Set()
  // );

  const {
    control,
    setValue,
    getValues,
    handleSubmit,
    formState: { errors },
    watch,
    trigger,
    setFocus,
  } = useForm<formValues>({
    defaultValues: {
      productCategory: null,
      productCategoryGet: null,
      discountId: null,
      fkDiscountTypeLookupValueId: "",
      discountName: ``,
      discountDescription: ``,
      isAutomatic: false,
      discountCode: ``,
      isSetDateRange: false,
      isSetSchedule: false,
      active: true,
      fkCustomerTargetTypeLookupValueId: btoa(`139`),
      ui_maxdiscountallowed: null,
      customerGroups: [],
      locations: [],
      products: [],
      buyProductQuantity: 0,
      getProductQuantity: 0,
      rules: [
        {
          discountRuleId: ``,
          fkDiscountValueTypeLookupValueId: null,
          discountValue: `0.00`,
          fkMinimumRequirementTypeLookupValueId: null,
          minPurchaseAmount: `0`,
          minPurchaseQty: `0`,
          maxPurchaseQty: `0`,
          fkMaxLimitTypeLookupValueId: null,
          maxAllowedQty: `0`,
          maxAllowedValue: `0`,
          totalUsageLimit: `0`,
          limitToOneUsePerCustomer: false,
          requiredQuantity: `0`,
          active: true,
        },
      ],
      dateRanges: [
        { discountScheduleDateRangeId: ``, startDate: ``, endDate: `` },
      ],
      weeklySchedules: [
        {
          discountScheduleWeeklyId: ``,
          dayOfWeek: `1`,
          startTime: ``,
          endTime: ``,
          isActive: false,
        },
        {
          discountScheduleWeeklyId: ``,
          dayOfWeek: `2`,
          startTime: ``,
          endTime: ``,
          isActive: false,
        },
        {
          discountScheduleWeeklyId: ``,
          dayOfWeek: `3`,
          startTime: ``,
          endTime: ``,
          isActive: false,
        },
        {
          discountScheduleWeeklyId: ``,
          dayOfWeek: `4`,
          startTime: ``,
          endTime: ``,
          isActive: false,
        },
        {
          discountScheduleWeeklyId: ``,
          dayOfWeek: `5`,
          startTime: ``,
          endTime: ``,
          isActive: false,
        },
        {
          discountScheduleWeeklyId: ``,
          dayOfWeek: `6`,
          startTime: ``,
          endTime: ``,
          isActive: false,
        },
        {
          discountScheduleWeeklyId: ``,
          dayOfWeek: `0`,
          startTime: ``,
          endTime: ``,
          isActive: false,
        },
      ],
    },
  });

  const discountType = watch(`rules.0.fkDiscountValueTypeLookupValueId`)
    ? watch(`rules.0.fkDiscountValueTypeLookupValueId.value`)
    : null;
    const discountValue = Number(watch(`rules.0.discountValue`)) || 0;
    useEffect(() => {
      if(discountValue>100 && discountType == 48){
     setValue("rules.0.discountValue", "0");}
    }, [discountType, setValue]);

    useEffect(() => {
        setFocus("discountName");
    }, [setFocus]);

    // Validation messages (rules={{ required: t(...) }}) are resolved once, at the
    // moment validation runs, and cached as plain strings in react-hook-form's error
    // state -- they don't re-render on their own. Re-validate any already-errored
    // fields on a language switch so their messages catch up to the new language.
    useEffect(() => {
        if (Object.keys(errors).length > 0) {
            trigger();
        }
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [i18n.language]);

  const categoriesApi = useCategoriesApi();
  const { showLoader, hideLoader } = useAppLoader();
  const [saving, setSaving] = useState<boolean>(false);
  const [showAddDiscountModal, setShowAddDiscountModal] =
    useState<boolean>(false);
  const [showAddDiscountModalForGet, setShowAddDiscountModalForGet] =
    useState<boolean>(false);
  const [showSelectAllModal, setShowSelectAllModal] =
    useState<boolean>(false);
  const [showSelectAllModalForGet, setShowSelectAllModalForGet] =
    useState<boolean>(false);
  const maxdiscountrenderRef = useRef<boolean>(false);
  const dayNameObj = {
    0: t("buyXGetYDiscount.schedule.dayNames.sunday"),
    1: t("buyXGetYDiscount.schedule.dayNames.monday"),
    2: t("buyXGetYDiscount.schedule.dayNames.tuesday"),
    3: t("buyXGetYDiscount.schedule.dayNames.wednesday"),
    4: t("buyXGetYDiscount.schedule.dayNames.thursday"),
    5: t("buyXGetYDiscount.schedule.dayNames.friday"),
    6: t("buyXGetYDiscount.schedule.dayNames.saturday"),
  };
  const lookup = useLookup();
  const commonApi = useCommonApi();
  const brandsApi = useBrandsApi();
  const unitsApi = useUnitsApi();
  const tagsApi = useTagsApi();
  const vendorsApi = useVendorsApi();
  const isAutomaticWatch = watch("isAutomatic");
  const ui_minrequirementtyopevalues = watch(
    "rules.0.fkMinimumRequirementTypeLookupValueId"
  );
  const ui_maxdiscountallowedWatch = watch(
    "rules.0.fkMaxLimitTypeLookupValueId"
  );
  const locations = useLocationsSelector();
  const weeklySchedulesWatch: any = watch("weeklySchedules");
  const isSetDateRangeWatch: boolean = watch("isSetDateRange");
  const isSetScheduleWatch: boolean = watch("isSetSchedule");
  const schedulestartdateWatch: any = watch("dateRanges.0.startDate");
  const scheduleenddateWatch: any = watch("dateRanges.0.endDate");
  const fkCustomerTargetTypeLookupValueIdWatch = watch("fkCustomerTargetTypeLookupValueId");
  const locationsWatch: any = watch("locations");

  // Set default tab based on type prop or URL parameter
  const getDefaultTab = () => {
    // console.log("getDefaultTab called with type:", type, "params:", params);

    // Try to get type from prop first, then from URL params
    const typeValue = type?.value?.toLowerCase() || params.type?.toLowerCase();
    // console.log("typeValue determined as:", typeValue);

    if (typeValue === "mtm0") {
      return "Special Pricing";
    } else if (typeValue === "mtm1") {
      return "Mix & Match Pricing";
    }
    return "Special Pricing"; // default fallback
  };

  const [activeTab, setActiveTab] = useState("Special Pricing");
  const [categoryDisabled, setCategoryDisabled] = useState(false);
  const [productData, setProductData] = useState<any>(null);
  const [productDataTree, setProductDataTree] = useState<any>(null);
  const [productDataGet, setProductDataGet] = useState<any>(null);
  const [productDataTreeGet, setProductDataTreeGet] = useState<any>(null);

  const tabs = [
    { name: "Special Pricing", label: t("buyXGetYDiscount.tabs.specialPricing"), disabled: false },
    { name: "Mix & Match Pricing", label: t("buyXGetYDiscount.tabs.mixMatchPricing"), disabled: false },
  ];

  const generateUniqueCode = (length = 5): string => {
    const chars = "abcdefghijklmnopqrstuvwxyz0123456789";
    let code = "";
    for (let i = 0; i < length; i++) {
      code += chars.charAt(Math.floor(Math.random() * chars.length));
    }
    return code.toUpperCase();
  };

  const formatDateForAPI = (date: Date | null, isEnd: boolean = false) => {
        if (!date) return undefined;
        if (isEnd) {
          return (
            moment(date).endOf("day").utc().format("YYYY-MM-DDTHH:mm:ss.SSS") + "Z"
            // moment(date).endOf("day").format("YYYY-MM-DDTHH:mm:ss.SSS") + "Z"
          );
        }
        return (
          moment(date).startOf("day").utc().format("YYYY-MM-DDTHH:mm:ss.SSS") + "Z"
          // moment(date).startOf("day").format("YYYY-MM-DDTHH:mm:ss.SSS") + "Z"
        );
  };
  

  const closeAddDiscountModal = (success: boolean = false) => {
    setShowAddDiscountModal(false);
  };

  const closeAddDiscountModalForGet = (success: boolean = false) => {
    setShowAddDiscountModalForGet(false);
  };

  const closeSelectAllModal = () => {
    setShowSelectAllModal(false);
  };

  const closeSelectAllModalForGet = () => {
    setShowSelectAllModalForGet(false);
  };

  // Create inventory options for all products
  const inventoryData = useMemo(() => {
    const data: { [key: string]: any } = {};

    productDataTree?.forEach((product: any) => {
      const getInventoryOptions = (inventoryLevels: any[]) => {
        if (!inventoryLevels || inventoryLevels.length === 0) {
          return [{ label: t("buyXGetYDiscount.values.noStockData"), value: "none" }];
        }

        // Get selected location IDs
        const selectedLocationIds = locationsWatch?.map((loc: any) => loc.value) || [];
        console.log("Inventory Levels ====>", inventoryLevels);
        // Filter inventory levels to only include selected locations
        const filteredInventoryLevels = inventoryLevels.filter((level: any) =>
          selectedLocationIds.includes(level.fkLocationId)
        );

        if (filteredInventoryLevels.length === 0) {
          return [{ label: t("buyXGetYDiscount.values.noStockData"), value: "none" }];
        }

        // Group by fkLocationId and sum quantities
        const locationMap = new Map();

        filteredInventoryLevels.forEach((level: any) => {
          const locationId = level.fkLocationId;
          const quantity = level.quantityInStock || 0;

          if (locationMap.has(locationId)) {
            locationMap.set(locationId, locationMap.get(locationId) + quantity);
          } else {
            locationMap.set(locationId, quantity);
          }
        });

        // Convert to options array
        return Array.from(locationMap.entries()).map(
          ([locationId, totalQuantity]) => {
            // Find location name from locations selector using fkLocationId
            const location = locations?.find(
              (loc: any) => loc.locationId === locationId
            );
            const locationName = location?.locationName || t("buyXGetYDiscount.values.unknownLocation");

            return {
              label: product.trackInventory === false
                ? `${locationName} (-)`
                : `${locationName} (${totalQuantity})`,
              value: locationId || "unknown",
            };
          }
        );
      };

      const inventoryOptions = getInventoryOptions(product.inventoryLevels);
      const firstOption = inventoryOptions[0];

      data[product.id] = {
        options: inventoryOptions,
        firstOption,
        displayText: firstOption?.label || t("buyXGetYDiscount.values.noStock"),
      };
    });

    return data;
  }, [productDataTree, locations, locationsWatch, t]);

  const inventoryDataGet = useMemo(() => {
    const data: { [key: string]: any } = {};
    productDataTreeGet?.forEach((product: any) => {
      const getInventoryOptions = (inventoryLevels: any[]) => {
        if (!inventoryLevels || inventoryLevels.length === 0) {
          return [{ label: t("buyXGetYDiscount.values.noStockData"), value: "none" }];
        }

        // Get selected location IDs
        const selectedLocationIds = locationsWatch?.map((loc: any) => loc.value) || [];
        
        // Filter inventory levels to only include selected locations
        const filteredInventoryLevels = inventoryLevels.filter((level: any) =>
          selectedLocationIds.includes(level.fkLocationId)
        );

        if (filteredInventoryLevels.length === 0) {
          return [{ label: t("buyXGetYDiscount.values.noStockData"), value: "none" }];
        }

        // Group by fkLocationId and sum quantities
        const locationMap = new Map();
        filteredInventoryLevels.forEach((level: any) => {
          const locationId = level.fkLocationId;
          const quantity = level.quantityInStock || 0;
          if (locationMap.has(locationId)) {
            locationMap.set(locationId, locationMap.get(locationId) + quantity);
          } else {
            locationMap.set(locationId, quantity);
          }
        });
        // Convert to options array
        return Array.from(locationMap.entries()).map(
          ([locationId, totalQuantity]) => {
            // Find location name from locations selector using fkLocationId
            const location = locations?.find(
              (loc: any) => loc.locationId === locationId
            );
            const locationName = location?.locationName || t("buyXGetYDiscount.values.unknownLocation");
            return {
              label: product.trackInventory === false
                ? `${locationName} (-)`
                : `${locationName} (${totalQuantity})`,
              value: locationId || "unknown",
            };
          }
        );
      };
      const inventoryOptions = getInventoryOptions(product.inventoryLevels);
      const firstOption = inventoryOptions[0];
      data[product.id] = {
        options: inventoryOptions,
        firstOption,
        displayText: firstOption?.label || t("buyXGetYDiscount.values.noStock"),
      };
    });
    return data;
  }, [productDataTreeGet, locations, locationsWatch, t]);

  const searchConfirm = (selectedProducts: any) => {
    // console.log("Product Data is: ->", productData);
    // console.log("Selected products are: ->", selectedProducts);

    if (!productData || productData.length === 0) {
      // If no existing data, just set the selected products
      setProductData(selectedProducts);
    } else {
      // Smart merge logic
      const updatedProductData: any[] = [];

      // First, add existing items that are still in selectedProducts (preserve existing data)
      productData.forEach((existingProduct: any) => {
        const foundInSelected = selectedProducts.find(
          (sp: any) => sp.productId === existingProduct.productId
        );
        if (foundInSelected) {
          updatedProductData.push(existingProduct);
        }
      });

      // Then, add new items from selectedProducts that weren't in productData
      selectedProducts.forEach((selectedProduct: any) => {
        const existsInCurrent = productData.find(
          (pd: any) => pd.productId === selectedProduct.productId
        );
        if (!existsInCurrent) {
          updatedProductData.push(selectedProduct);
        }
      });

      setProductData(updatedProductData);
    }

    setShowAddDiscountModal(false);
  };

  const searchConfirmGet = (selectedProducts: any) => {
    // console.log("Product Data is: ->", productData);
    // console.log("Selected products are: ->", selectedProducts);
    if (!productDataGet || productDataGet.length === 0) {
      // If no existing data, just set the selected products
      setProductDataGet(selectedProducts);
    } else {
      // Smart merge logic
      const updatedProductData: any[] = [];
      // First, add existing items that are still in selectedProducts (preserve existing data)
      productDataGet.forEach((existingProduct: any) => {
        const foundInSelected = selectedProducts.find(
          (sp: any) => sp.productId === existingProduct.productId
        );
        if (foundInSelected) {
          updatedProductData.push(existingProduct);
        }
      });
      // Then, add new items from selectedProducts that weren't in productData
      selectedProducts.forEach((selectedProduct: any) => {
        const existsInCurrent = productDataGet.find(
          (pd: any) => pd.productId === selectedProduct.productId
        );
        if (!existsInCurrent) {
          updatedProductData.push(selectedProduct);
        }
      });
      setProductDataGet(updatedProductData);
    }
    setShowAddDiscountModalForGet(false);
  };

  const confirmDelete = async (product: any) => {
    // console.log("Delete product is: ->", product);
    setProductData((prev: any) => {
      if (!prev) return prev;
      return prev.filter((p: any) => p.productId !== product.productId);
    });
  };

  const confirmDeleteGet = async (product: any) => {
    // console.log("Delete product is: ->", product);
    setProductDataGet((prev: any) => {
      if (!prev) return prev;
      return prev.filter((p: any) => p.productId !== product.productId);
    });
  };

  const onSubmit = async (data: formValues) => {
    // console.log("Form data is: ->", data);
    const payload = Object.assign({}, JSON.parse(JSON.stringify(data)));
    if (
      data &&
      data?.locations &&
      Array.isArray(data.locations) &&
      data.locations.length > 0
    ) {
      payload.locations = data.locations.map((x: any) => {
        const lobj = {
          discountLocationId: null,
          fkLocationId: x.value,
          active: true,
        };
        if (
          discount &&
          discount.locations &&
          Array.isArray(discount.locations)
        ) {
          // console.log(discount.locations, x.value);
          const existLocaton = discount.locations.find(
            (y: any) => y.fkLocationId == x.value
          );
          if (existLocaton) {
            lobj.discountLocationId = existLocaton.discountLocationId;
          }
        }
        return lobj;
      });
    }

    // Process customer groups
    if (data && data?.customerGroups && Array.isArray(data.customerGroups) && data.customerGroups.length > 0) {
      payload.customerGroups = data.customerGroups.map((x: any) => {
        const cgobj = { discountCustomerGroupId: null, fkCustomerGroupId: x.value, active: true }
        if (discount && discount.customerGroups && Array.isArray(discount.customerGroups)) {
          const existCustomerGroup = discount.customerGroups.find((y: any) => y.fkCustomerGroupId == x.value);
          if (existCustomerGroup) {
            cgobj.discountCustomerGroupId = existCustomerGroup.discountCustomerGroupId;
          }
        }
        return cgobj;
      });
    } else {
      payload.customerGroups = [];
    }

    if (
      data &&
      data?.rules &&
      Array.isArray(data.rules) &&
      data.rules.length > 0
    ) {
      payload.rules = data.rules.map((x: any) => ({
        discountRuleId: null,
        fkDiscountValueTypeLookupValueId:
          x.fkDiscountValueTypeLookupValueId &&
          typeof x.fkDiscountValueTypeLookupValueId !== `undefined` &&
          x.fkDiscountValueTypeLookupValueId?.value
            ? btoa(x.fkDiscountValueTypeLookupValueId.value)
            : ``,
        discountValue: Number(x.discountValue) || 0,
        // fkMinimumRequirementTypeLookupValueId:
        //   x.fkMinimumRequirementTypeLookupValueId &&
        //   typeof x.fkMinimumRequirementTypeLookupValueId !== `undefined` &&
        //   x.fkMinimumRequirementTypeLookupValueId?.value
        //     ? btoa(x.fkMinimumRequirementTypeLookupValueId.value)
        //     : ``,
        minPurchaseAmount: Number(x.minPurchaseAmount) || 0,
        minPurchaseQty: null,
        maxPurchaseQty: null,
        // fkMaxLimitTypeLookupValueId:
        //   x.fkMaxLimitTypeLookupValueId &&
        //   typeof x.fkMaxLimitTypeLookupValueId !== `undefined` &&
        //   x.fkMaxLimitTypeLookupValueId?.value
        //     ? btoa(x.fkMaxLimitTypeLookupValueId.value)
        //     : ``,
        maxAllowedQty: null,
        maxAllowedValue: null,
        // totalUsageLimit: Number(x.limitToOneUsePerCustomer)
        //   ? 1
        //   : Number(x?.totalUsageLimit) || 0,
        // limitToOneUsePerCustomer: x.limitToOneUsePerCustomer,
        requiredQuantity: Number(data?.buyProductQuantity) || 0,
        customerGetProductQuantity: Number(data?.getProductQuantity) || 0,
        active: true,
      }));
    }

    if (
      data &&
      data?.isSetDateRange &&
      data?.dateRanges &&
      Array.isArray(data.dateRanges) &&
      data.dateRanges.length > 0
    ) {
      payload.dateRanges = data.dateRanges.map((x: any) => ({
        discountScheduleDateRangeId: ``,
        startDate: formatDateForAPI(x.startDate),
        endDate: formatDateForAPI(x.endDate, true),
      }));
    } else {
      payload.dateRanges = [];
    }

    if (
      data &&
      data?.isSetSchedule &&
      data.isSetSchedule === true &&
      data?.weeklySchedules &&
      Array.isArray(data.weeklySchedules) &&
      data.weeklySchedules.length > 0
    ) {
      payload.weeklySchedules = data.weeklySchedules
        .filter((x: any) => x.isActive)
        .map((x: any) => {
          var lobj = {
            discountScheduleWeeklyId: ``,
            dayOfWeek: x.dayOfWeek,
            startTime: x.startTime
              ? moment(x.startTime).utc().format(`HH:mm`)
              : null,
            endTime: x.endTime ? moment(x.endTime).utc().format(`HH:mm`) : null,
            // startTime: x.startTime
            //   ? moment(x.startTime).format(`HH:mm`)
            //   : null,
            // endTime: x.endTime ? moment(x.endTime).format(`HH:mm`) : null,
            isActive: x.isActive,
          };
          if (
            discount &&
            discount.weeklySchedules &&
            Array.isArray(discount.weeklySchedules)
          ) {
            //console.log(discount.weeklySchedules, x.value)
            const existSchedule = discount.weeklySchedules.find(
              (y: any) => y.dayOfWeek == x.dayOfWeek
            );
            if (existSchedule) {
              lobj.discountScheduleWeeklyId =
                existSchedule.discountScheduleWeeklyId;
            }
          }
          return lobj;
        });
    } else {
      payload.weeklySchedules = [];
    }
    delete payload.ui_maxdiscountallowed;
    payload.fkDiscountTypeLookupValueId = type?.value || type;

    const buyProducts =
      productDataTree?.map((p: any) => ({
        // discountProductId: null,
        fkProductId: p.productId,
        fkProductVariantDetailId: p.isVariant ? p.variantId : null,
        fkProductRoleLookupValueId: btoa(`144`),
        // requiredQuantity: 0,
        fkProductStatusLookupValueId: p.isActive ? btoa(`141`) : btoa(`142`),
      })) || [];

    const getProducts =
      productDataTreeGet?.map((p: any) => ({
        // discountProductId: null,
        fkProductId: p.productId,
        fkProductVariantDetailId: p.isVariant ? p.variantId : null,
        fkProductRoleLookupValueId: btoa(`145`),
        // requiredQuantity: 0,
        fkProductStatusLookupValueId: p.isActive ? btoa(`141`) : btoa(`142`),
      })) || [];

    payload.products = [...buyProducts, ...getProducts];
    payload.discountCode = generateUniqueCode(10);
    // console.log("Final processed payload is: ->", payload);
    // return;
    setSaving(true);
    showLoader();
    const couponresp: any = await new Promise((resolve, reject) =>
      discountApi.addUpdateDiscount(payload, resolve, reject)
    ).catch((err) => null);
    setSaving(false);
    hideLoader();
    // console.log("Coupon Response", couponresp);
    if (couponresp && couponresp?.success && couponresp.success == true) {
      toast.success(t("buyXGetYDiscount.toasts.saveSuccess"));
      navigate(URLS.DISCOUNT);
    } else {
      toast.error(couponresp?.errorMessage || t("buyXGetYDiscount.toasts.saveFailed"));
    }
  };

  const handleCancel = () => {
    navigationConfirm(
      t("common.leaveDialog.title"),
      t("common.leaveDialog.message"),
      () => navigate(URLS.DISCOUNT),
      confirm
    );
  };

  const transformProductsToTree = (products: any[]): any[] => {
    const result: any[] = [];

    products.forEach((product: any) => {
      // Add main product
      const mainProduct = {
        ...product,
        id: product.productId,
        name: product.productName,
        level: 0,
        hasChildren: product.variants && product.variants.length > 0,
        expanded: false,
        isVariant: false,
        variantKey: null,
      };

      result.push(mainProduct);

      // Add variants as children if they exist
      if (product.variants && product.variants.length > 0) {
        product.variants.forEach((variant: any, index: number) => {
          const variantProduct = {
            ...product, // Inherit product data first
            ...variant, // Then override with variant-specific data
            variants: undefined, // Remove variants from variant to avoid recursion
            id: `${product.productId}_${variant.productVariantDetailId}`,
            productId: product.productId,
            variantId: variant.productVariantDetailId,
            name: `${product.productName} - ${
              variant.attributes
                ?.map(
                  (attr: any) => `${attr.attributeName}: ${attr.attributeValue}`
                )
                .join(", ") || `Variant ${index + 1}`
            }`,
            productName: `${product.productName} - ${
              variant.attributes
                ?.map(
                  (attr: any) => `${attr.attributeName}: ${attr.attributeValue}`
                )
                .join(", ") || `Variant ${index + 1}`
            }`,
            level: 1,
            hasChildren: false,
            expanded: false,
            isVariant: true,
            variantKey: variant.productVariantDetailId,
            parentId: product.productId,
            // Ensure variant-specific data takes precedence
            prices: variant.prices || [],
            inventoryLevels: variant.inventoryLevels || [],
            productImages: variant.productImages || product.productImages || [],
            isActive: variant.isActive, // Explicitly preserve variant's isActive status
          };

          result.push(variantProduct);
        });
      }
    });

    return result;
  };

  const handleToggleExpand = (productId: string) => {
    setExpandedProducts((prev) => {
      const newExpanded = new Set(prev);
      if (newExpanded.has(productId)) {
        newExpanded.delete(productId);
      } else {
        newExpanded.add(productId);
      }
      return newExpanded;
    });
  };

  const handleProductSelection = (product: any, isActive: boolean) => {
    // console.log("productData before toggle is: ->", productData);
    // console.log("current product / product Variant is : ->", product);
    // console.log("isActive value is : ->", isActive);

    setProductData((prevProductData: any[]) => {
      return prevProductData?.map((p: any) => {
        // If this is a main product (not a variant)
        if (!product.isVariant && p.productId === product.productId) {
          // Update main product isActive
          const updatedProduct = { ...p, isActive: isActive };
          // console.log("Updated main product is: ->", updatedProduct);

          // Set all variants to the same isActive status as the parent product
          if (updatedProduct.variants && updatedProduct.variants.length > 0) {
            updatedProduct.variants = updatedProduct.variants?.map(
              (variant: any) => ({
                ...variant,
                isActive: isActive,
              })
            );
          }

          return updatedProduct;
        }

        // If this is a variant and we found the parent product
        if (
          product.isVariant &&
          p.productId === product.productId &&
          p.variants &&
          p.variants.length > 0
        ) {
          const updatedVariants = p.variants?.map((variant: any) => {
            if (variant.productVariantDetailId === product.variantId) {
              // console.log("Updating variant: ->", {...variant, isActive});
              return { ...variant, isActive: isActive };
            }
            return variant;
          });

          // Check if all variants are active to determine parent product status
          const allVariantsActive = updatedVariants.every(
            (variant: any) => variant.isActive
          );

          return {
            ...p,
            variants: updatedVariants,
            isActive: allVariantsActive, // Parent is active only if ALL variants are active
          };
        }

        return p;
      });
    });
  };

  const handleProductSelectionGet = (product: any, isActive: boolean) => {
    // console.log("productData before toggle is: ->", productData);
    // console.log("current product / product Variant is : ->", product);
    // console.log("isActive value is : ->", isActive);
    setProductDataGet((prevProductData: any[]) => {
      return prevProductData?.map((p: any) => {
        // If this is a main product (not a variant)
        if (!product.isVariant && p.productId === product.productId) {
          // Update main product isActive
          const updatedProduct = { ...p, isActive: isActive };
          // console.log("Updated main product is: ->", updatedProduct);
          // Set all variants to the same isActive status as the parent product
          if (updatedProduct.variants && updatedProduct.variants.length > 0) {
            updatedProduct.variants = updatedProduct.variants?.map(
              (variant: any) => ({
                ...variant,
                isActive: isActive,
              })
            );
          }
          return updatedProduct;
        }
        // If this is a variant and we found the parent product
        if (
          product.isVariant &&
          p.productId === product.productId &&
          p.variants &&
          p.variants.length > 0
        ) {
          const updatedVariants = p.variants?.map((variant: any) => {
            if (variant.productVariantDetailId === product.variantId) {
              // console.log("Updating variant: ->", {...variant, isActive});
              return { ...variant, isActive: isActive };
            }
            return variant;
          });
          // Check if all variants are active to determine parent product status
          const allVariantsActive = updatedVariants.every(
            (variant: any) => variant.isActive
          );
          return {
            ...p,
            variants: updatedVariants,
            isActive: allVariantsActive, // Parent is active only if ALL variants are active
          };
        }
        return p;
      });
    });
  };

  const getVisibleProducts = () => {
    return productDataTree?.filter((product: any) => {
      if (!product.isVariant) {
        return true; // Always show main products
      }
      // Show variants only if their parent is expanded
      return expandedProducts.has(product.parentId);
    });
  };

  const getVisibleProductsGet = () => {
    return productDataTreeGet?.filter((product: any) => {
      if (!product.isVariant) {
        return true; // Always show main products
      }
      // Show variants only if their parent is expanded
      return expandedProducts.has(product.parentId);
    });
  };

  useEffect(() => {
    const transformedProduct = transformProductsToTree(productData || []);
    // console.log("Transformed Product Data Tree: ->", transformedProduct);
    setProductDataTree(transformedProduct);
  }, [productData]);

  useEffect(() => {
    const transformedProduct = transformProductsToTree(productDataGet || []);
    // console.log("Transformed Product Data Tree: ->", transformedProduct);
    setProductDataTreeGet(transformedProduct);
  }, [productDataGet]);

  useEffect(() => {
    categoriesApi.searchCategory(
      {},
      () => {
        // Categories loaded successfully and stored in Redux
      },
      (error: any) => {
        console.log("Categories load error:", error);
      }
    );

    // Load locations - saga will automatically store in Redux
    commonApi.locationSearch(
      {},
      () => {},
      (error: any) => {
        console.log("Locations load error:", error);
      }
    );

    // Load brands - saga will automatically store in Redux
    brandsApi.searchBrand(
      {},
      () => {},
      (error: any) => {
        console.log("Brands load error:", error);
      }
    );

    // Load units - saga will automatically store in Redux
    unitsApi.searchUnit(
      {},
      () => {},
      (error: any) => {
        console.log("Units load error:", error);
      }
    );

    // Load tags - saga will automatically store in Redux
    tagsApi.searchTag(
      {},
      () => {},
      (error: any) => {
        console.log("Tags load error:", error);
      }
    );

    // Load vendors - saga will automatically store in Redux
    vendorsApi.searchVendor(
      {},
      () => {},
      (error: any) => {
        console.log("Vendors load error:", error);
      }
    );

    // console.log("Discount is -> ", discount);
    if (discount) {
      setValue(`discountId`, discount.discountId || null);
      setValue(
        `fkDiscountTypeLookupValueId`,
        discount.fkDiscountTypeLookupValueId
      );
      setValue(`discountName`, discount.discountName || ``);
      setValue(`discountDescription`, discount.discountDescription || ``);
      setValue(`isAutomatic`, discount.isAutomatic);
      setValue(`discountCode`, discount.discountCode);
      setValue(`isSetDateRange`, discount.isSetDateRange);
      setValue(`isSetSchedule`, discount.isSetSchedule);
      setValue(`active`, discount.active);
      setValue(
        `fkCustomerTargetTypeLookupValueId`,
        discount.fkCustomerTargetTypeLookupValueId
      );
      setValue(`locations`, discount.locations);
      setValue(`customerGroups`, discount.customerGroups);
      maxdiscountrenderRef.current = true;
      if (
        discount.rules &&
        Array.isArray(discount.rules) &&
        discount.rules.length > 0
      ) {
        setValue(
          `rules`,
          discount.rules.map((x: any) => {
            //console.log("x.limitToOneUsePerCustomer", x.limitToOneUsePerCustomer, x.totalUsageLimit);
            return {
              discountRuleId: x.discountRuleId,
              fkDiscountValueTypeLookupValueId:
                x.fkDiscountValueTypeLookupValueId,
              discountValue: x.discountValue ? parseFloat(x.discountValue).toFixed(2) : ``,
              fkMinimumRequirementTypeLookupValueId:
                x.fkMinimumRequirementTypeLookupValueId,
              minPurchaseAmount: x.minPurchaseAmount,
              minPurchaseQty: x.minPurchaseQty,
              maxPurchaseQty: x.maxPurchaseQty,
              fkMaxLimitTypeLookupValueId: x.fkMaxLimitTypeLookupValueId,
              maxAllowedQty: x.maxAllowedQty,
              maxAllowedValue: x.maxAllowedValue,
              totalUsageLimit: `` + x.totalUsageLimit,
              limitToOneUsePerCustomer: x.limitToOneUsePerCustomer,
              requiredQuantity: x.requiredQuantity,
              active: x.active,
            };
          })
        );

        const buyProductRequiredQuantity =
          discount.rules[0]?.requiredQuantity || 0;
        setValue(`buyProductQuantity`, buyProductRequiredQuantity);

        const getProductGetQuantity =
          discount.rules[0]?.customerGetProductQuantity || 0;
        setValue(`getProductQuantity`, getProductGetQuantity);
      }

      if (
        discount.isSetDateRange &&
        discount.dateRanges &&
        Array.isArray(discount.dateRanges) &&
        discount.dateRanges.length > 0
      ) {
        setValue(
          `dateRanges`,
          discount.dateRanges.map((x: any) => {
            return {
              discountScheduleDateRangeId: x.discountScheduleDateRangeId,
              // startDate: x.startDate ? moment.utc(x.startDate).toDate() : ``,
              // endDate: x.endDate ? moment.utc(x.endDate).toDate() : ``,
              startDate: x.startDate ? moment.utc(x.startDate).local().toDate() : ``,
              endDate: x.endDate ? moment.utc(x.endDate).local().toDate() : ``,
            };
          })
        );
      }

      const productDetails = [];
      if (discount?.productDetails && Array.isArray(discount?.productDetails)) {
        for (const pd of discount.productDetails) {
          productDetails.push(pd);
        }
      }

      if (discount?.products && Array.isArray(discount?.products)) {
        const products = discount?.products;
        // console.log("productDetails", productDetails)
        // console.log("products", products)

        // Separate products based on fKProductRoleLookupValueId
        const buyProducts = products.filter((p: any) => p.fkProductRoleLookupValueId === btoa(`144`));
        const getProducts = products.filter((p: any) => p.fkProductRoleLookupValueId === btoa(`145`));

        // Process Buy Products (144)
        const updateProductDetailsWithRole = (productDetailsList: any[], roleProducts: any[]) => {
          return productDetailsList.map((productDetail: any) => {
            // Find matching main product in role products array
            const mainProductData = roleProducts.find(
              (p: any) =>
                p.fkProductId === productDetail.productId &&
                p.fkProductVariantDetailId === null
            );

            // Set main product isActive status
            const mainProductActive = mainProductData
              ? mainProductData.fkProductStatusLookupValueId === "MTQx"
              : false;

            // Update variants if they exist
            let updatedVariants = productDetail.variants;
            if (
              productDetail.variants &&
              Array.isArray(productDetail.variants) &&
              productDetail.variants.length > 0
            ) {
              updatedVariants = productDetail.variants.map((variant: any) => {
                // Find matching variant in role products array
                const variantData = roleProducts.find(
                  (p: any) =>
                    p.fkProductId === productDetail.productId &&
                    p.fkProductVariantDetailId ===
                      variant.productVariantDetailId
                );

                // Set variant isActive status
                const variantActive = variantData
                  ? variantData.fkProductStatusLookupValueId === "MTQx"
                  : false;

                return {
                  ...variant,
                  isActive: variantActive,
                };
              });
            }

            return {
              ...productDetail,
              isActive: mainProductActive,
              variants: updatedVariants,
            };
          });
        };

        // Filter productDetails based on products with role 144 (Buy products)
        const buyProductDetails = productDetails.filter((pd: any) => 
          buyProducts.some((bp: any) => bp.fkProductId === pd.productId)
        );

        // Filter productDetails based on products with role 145 (Get products)
        const getProductDetails = productDetails.filter((pd: any) => 
          getProducts.some((gp: any) => gp.fkProductId === pd.productId)
        );

        // Update buy products with isActive property
        const updatedBuyProductDetails = updateProductDetailsWithRole(buyProductDetails, buyProducts);
        
        // Update get products with isActive property  
        const updatedGetProductDetails = updateProductDetailsWithRole(getProductDetails, getProducts);

        // console.log("Updated buy productDetails with isActive:", updatedBuyProductDetails);
        // console.log("Updated get productDetails with isActive:", updatedGetProductDetails);

        // Set the updated productDetails data
        setProductData(updatedBuyProductDetails || []);
        setProductDataGet(updatedGetProductDetails || []);
      }

      if (
        discount.isSetSchedule &&
        discount.weeklySchedules &&
        Array.isArray(discount.weeklySchedules) &&
        discount.weeklySchedules.length > 0
      ) {
        const wkarr: any = [];
        setValue(
          `weeklySchedules`,
          Object.keys(dayNameObj).map((x: any) => {
            const wkobj: any = discount.weeklySchedules.find(
              (y: any) => y.dayOfWeek == x
            );
            return {
              discountScheduleWeeklyId: wkobj?.discountScheduleWeeklyId || null,
              dayOfWeek: wkobj?.dayOfWeek || x,
              // If They send proper date-time ISO string.
              // startTime: wkobj?.startTime ? moment.utc(wkobj.startTime).toDate() : null,
              // endTime: wkobj?.endTime ? moment.utc(wkobj.endTime).toDate() : null,
              startTime: wkobj?.startTime
                ? moment.utc(`2025-01-01 ` + wkobj.startTime).toDate()
                : null,
              endTime: wkobj?.endTime
                ? moment.utc(`2025-01-01 ` + wkobj.endTime).toDate()
                : null,
              //   startTime: wkobj?.startTime
              //   ? moment(`2025-01-01 ` + wkobj.startTime).toDate()
              //   : null,
              // endTime: wkobj?.endTime
              //   ? moment(`2025-01-01 ` + wkobj.endTime).toDate()
              //   : null,
              isActive: wkobj ? true : false,
            };
          })
        );
      }
    }
  }, []);

  useEffect(() => {
    //console.log("discount ui_maxdiscountallowedWatch", ui_maxdiscountallowedWatch, discount);
    if (
      ui_maxdiscountallowedWatch &&
      typeof ui_maxdiscountallowedWatch !== `undefined` &&
      typeof ui_maxdiscountallowedWatch === `object` &&
      (ui_maxdiscountallowedWatch as any)?.value
    ) {
      setValue(
        `rules.0.limitToOneUsePerCustomer`,
        (ui_maxdiscountallowedWatch as any)?.value === 130
      );
      //if (!maxdiscountrenderRef.current)
      setValue(
        `rules.0.totalUsageLimit`,
        (ui_maxdiscountallowedWatch as any)?.value === 130
          ? `1`
          : getValues(`rules.0.totalUsageLimit`) || `0`
      );
    } else {
      setValue(`rules.0.limitToOneUsePerCustomer`, false);
      //if (!maxdiscountrenderRef.current)
      //setValue(`rules.0.totalUsageLimit`, `0`);
    }
  }, [ui_maxdiscountallowedWatch]);

  // Clear customer groups when switching to "all customers"
  useEffect(() => {
    if (fkCustomerTargetTypeLookupValueIdWatch === btoa(`139`)) {
      setValue(`customerGroups`, []);
    }
  }, [fkCustomerTargetTypeLookupValueIdWatch]);

  return (
    <div>
      <SubHeader
        title={t("buyXGetYDiscount.page.title")}
        subTitle={t("buyXGetYDiscount.page.subtitle")}
      >
        <SiteButtons
          data={[
            { text: t("buyXGetYDiscount.buttons.cancel"), ...(!saving && { click: handleCancel }), theme: "secondary" },
            {
              text: discount ? t("buyXGetYDiscount.buttons.update") : t("buyXGetYDiscount.buttons.save"),
              type: "submit",
              form: "createProductDiscountForm",
              working: saving,
            },
          ]}
        />
      </SubHeader>
      <Container>
        <div className="flex-grow overflow-auto">
          <form
            onSubmit={handleSubmit(onSubmit)}
            id="createProductDiscountForm"
          >
            <div className="pb-6 pt-6">
              {/* General Section */}
              <div>
                <div className={`border-b border-gray-300 pb-2 mb-6 `}>
                  <h2 className="text-lg font-semibold mb-2 text-black">
                    {t("buyXGetYDiscount.sections.general")}
                  </h2>
                  <p className="mb-4 text-sm text-black">{t("buyXGetYDiscount.sections.generalSubtitle")}</p>
                </div>
                <div className="grid grid-cols-1 gap-6 mb-6">
                  <div className="flex items-center gap-2">
                    <span className="text-sm font-normal text-black">
                      {t("buyXGetYDiscount.toggles.manual")}
                    </span>
                    <label className="relative inline-flex items-center cursor-pointer">
                      <input
                        type="checkbox"
                        className="sr-only peer hidden"
                        {...control.register("isAutomatic")}
                      />
                      <div className="w-11 h-6 bg-tertiary relative peer-focus:outline-none after:content-[''] after:top-1 after:absolute after:block after:w-4 after:h-4 after:bg-white after:rounded-full after:left-1 peer-focus:ring-blue-500 rounded-full peer peer-checked:bg-secondary peer-checked:after:right-1 peer-checked:after:left-auto  transition-all"></div>
                      <span className="ml-2 text-sm font-normal text-black">
                        {t("buyXGetYDiscount.toggles.automatic")}
                      </span>
                    </label>
                  </div>
                </div>
                <div className="grid grid-cols-1 md:grid-cols-2 gap-6 mb-6">
                  <div>
                    <Controller
                      name="discountName"
                      control={control}
                      rules={{
                        required: t("buyXGetYDiscount.validation.codeRequired"),
                        validate: (value: string | undefined) =>
                          !!(value?.trim()) || t("buyXGetYDiscount.validation.codeRequired"),
                      }}
                      render={({ field, fieldState }) => (
                        <Input
                          {...field}
                          className="!my-0 !mb-6"
                          type="text"
                          label={t("buyXGetYDiscount.fields.discountCode")}
                          required
                          placeholder={t("buyXGetYDiscount.placeholders.enterDiscountCode")}
                          error={fieldState.error?.message}
                        />
                      )}
                    />
                    <div>
                      <CommonDropdown
                        control={control}
                        setValue={setValue}
                        preSelectValues={
                          discount &&
                          discount.locations &&
                          Array.isArray(discount.locations)
                            ? discount.locations.map((o: any) => o.fkLocationId)
                            : null
                        }
                        rules={{ required: t("buyXGetYDiscount.validation.locationRequired") }}
                        label={t("buyXGetYDiscount.fields.location")}
                        name="locations"
                        type="location"
                        placeholder={t("buyXGetYDiscount.placeholders.selectLocation")}
                        required={true}
                        isMulti={true}
                      />
                    </div>
                  </div>
                  <Controller
                    name="discountDescription"
                    control={control}
                    render={({ field, fieldState }) => (
                      <Textarea
                        {...field}
                        className="!my-0 w-full"
                        mainElementClassName={`h-[132px]`}
                        label={t("buyXGetYDiscount.fields.discountDescription")}
                        placeholder={t("buyXGetYDiscount.placeholders.description")}
                        error={fieldState.error?.message}
                      />
                    )}
                  />
                </div>
              </div>

              {/* Buy X section*/}
              <div>
                <div className={`border-b border-gray-300 pb-2 mb-6 `}>
                  <h2 className="text-lg font-semibold mb-2 text-black">
                    {t("buyXGetYDiscount.sections.customerBuys")}
                  </h2>
                  {/* <p className="mb-4 text-sm text-black">
                    Choose When The Promotion Happens
                  </p> */}
                </div>
                <div className="grid grid-cols-1 md:grid-cols-2 gap-6 mb-0">
                  <Controller
                    name="rules.0.minPurchaseAmount"
                    control={control}
                    rules={{
                      required: t("buyXGetYDiscount.validation.minPurchaseAmountRequired"),
                      validate: (value) => {
                        const numValue = Number(value);
                        if (isNaN(numValue)) {
                          return t("buyXGetYDiscount.validation.minPurchaseAmountInvalid");
                        }
                        if (numValue <= 0) {
                          return t("buyXGetYDiscount.validation.minPurchaseAmountMin");
                        }
                        return true;
                      },
                    }}
                    render={({ field, fieldState }) => (
                      <DecimalInput
                        value={field.value ?? undefined}
                        onChange={field.onChange}
                        decimalPlaces={2} // allows decimals
                        min={0}
                        max={9999999999}
                        className="!my-0 !mb-6"
                        label={t("buyXGetYDiscount.fields.minPurchaseAmount")}
                        placeholder="50"
                        required
                        withDollarIcon={true}
                        error={fieldState.error?.message}
                      />
                    )}
                  />

                  {/* <Controller
                    name="rules.0.maxPurchaseQty"
                    control={control}
                    rules={{
                      required: "Min Purchase Amount is required",
                      validate: (value) => {
                        const numValue = Number(value);
                        if (isNaN(numValue)) {
                          return "Max Purchase Qty must be a valid number";
                        }
                        if (numValue < 0) {
                          return "Max Purchase Qty must be greater than or equal to 0";
                        }
                        return true;
                      },
                    }}
                    render={({ field, fieldState }) => (
                      <Input
                        {...field}
                        className="!my-0 !mb-6"
                        type="text"
                        label="Maximum Purchase Quantity"
                        placeholder="0"
                        required
                        error={fieldState.error?.message}
                        value={field.value ?? 0}
                      />
                    )}
                  /> */}
                </div>

                {/* <div className="mb-8">
                  <label className="block text-sm font-medium mb-1">
                    Combinations (This product discount can be combined with)
                  </label>
                  <select
                    className="w-full border border-gray-300 rounded-md px-3 py-2 focus:outline-none focus:ring-2 focus:ring-blue-500"
                    disabled
                  >
                    <option>Product Discounts</option>
                  </select>
                </div> */}
              </div>
              <div className="flex justify-between items-center w-full">
                <div className="w-full grid grid-cols-1 md:grid-cols-12 gap-6 mb-0">
                  {/* <div className="md:col-span-5">
                    <CommonDropdown
                      control={control}
                      setValue={setValue}
                      label="Select Products Category"
                      name="productCategory"
                      type="categorytreebind"
                      className="!my-0"
                      placeholder="Select Category"
                      // required
                      disabled={categoryDisabled}
                    />
                  </div> */}

                  <div className="md:col-span-6">
                    <Controller
                      name="buyProductQuantity"
                      control={control}
                      rules={{
                        required: t("buyXGetYDiscount.validation.productQuantityRequired"),
                        validate: (value) => {
                          const numValue = Number(value);
                          if (isNaN(numValue)) {
                            return t("buyXGetYDiscount.validation.productQuantityInvalid");
                          }
                          if (numValue < 1) {
                            return t("buyXGetYDiscount.validation.productQuantityMin");
                          }
                          return true;
                        },
                      }}
                      render={({ field, fieldState }) => (
                        <DecimalInput
                          value={field.value ?? 0}
                          onChange={field.onChange}
                          fieldType="unit" // restricts to whole numbers
                          max={9999999999}
                          className="!my-0 !mb-6"
                          label={t("buyXGetYDiscount.fields.productQuantity")}
                          placeholder="50"
                          required
                          error={fieldState.error?.message}
                        />
                      )}
                    />
                  </div>
                  <div className="md:col-span-2"></div>
                  <div className="flex justify-end items-center gap-2 md:col-span-4">
                    <Button
                      type="button"
                      theme="secondary"
                      onClick={() => {
                        const selectedLocations = getValues("locations");
                        if (!selectedLocations || selectedLocations.length === 0) {
                          toast.error(t("buyXGetYDiscount.validation.selectLocationFirst"));
                          return;
                        }
                        setShowSelectAllModal(true);
                      }}
                    >
                      {t("buyXGetYDiscount.buttons.selectAllProducts")}
                    </Button>
                    <Button
                      type="button"
                      onClick={() => {
                        const selectedLocations = getValues("locations");
                        if (!selectedLocations || selectedLocations.length === 0) {
                          toast.error(t("buyXGetYDiscount.validation.selectLocationFirst"));
                          return;
                        }
                        setShowAddDiscountModal(true);
                      }}
                    >
                      {t("buyXGetYDiscount.buttons.searchProduct")}
                    </Button>
                  </div>
                </div>

                {showAddDiscountModal && (
                  <SiteModal
                    modalWidth={1000}
                    width={true}
                    isOpen={showAddDiscountModal}
                    onClose={closeAddDiscountModal}
                    title={t("buyXGetYDiscount.modal.selectProductsTitle")}
                    isBlur={true}
                    closeOnBackdrop={false}
                  >
                    <ProductSearchModal
                      // category={getValues(`productCategory`)? [getValues(`productCategory`)]: []}
                      category={[]}
                      onClose={closeAddDiscountModal}
                      onConfirm={searchConfirm}
                      productData={productData}
                      disableCategory={false}
                      location={getValues("locations") || []}
                    ></ProductSearchModal>
                  </SiteModal>
                )}

                {showSelectAllModal && (
                  <SiteModal
                    modalWidth={1000}
                    width={true}
                    isOpen={showSelectAllModal}
                    onClose={closeSelectAllModal}
                    title={t("buyXGetYDiscount.modal.selectProductsTitle")}
                    isBlur={true}
                    closeOnBackdrop={false}
                  >
                    <ProductSearchModalAll
                      category={[]}
                      onClose={closeSelectAllModal}
                      onConfirm={(selected: any) => {
                        searchConfirm(selected);
                        setShowSelectAllModal(false);
                      }}
                      productData={productData}
                      disableCategory={false}
                      location={getValues("locations") || []}
                    ></ProductSearchModalAll>
                  </SiteModal>
                )}
              </div>
              <div className="mt-6">
                <ReusableTable
                  fixedHeight="calc(100vh - 200px)"
                  paddingBottomNeeded={productDataTree?.length > 0}
                  data={getVisibleProducts()}
                  enableExpand={false}
                  columns={[
                    {
                      key: "productName",
                      label: t("buyXGetYDiscount.columns.productName"),
                      sortable: false,
                      render: (product: any) => (
                        <div className="flex items-center gap-2">
                          {/* Indentation for tree structure */}
                          <div
                            style={{ marginLeft: product.level * 20 }}
                            className="flex items-center gap-2"
                          >
                            {/* Expand/Collapse button for products with variants */}
                            {product.hasChildren && (
                              <button
                                type="button"
                                onClick={() =>
                                  handleToggleExpand(product.productId)
                                }
                                className="w-6 h-6 flex cursor-pointer items-center justify-center text-gray-600 hover:text-gray-800 hover:bg-gray-100 rounded transition-colors"
                              >
                                <Icon
                                  name={
                                    expandedProducts.has(product.productId)
                                      ? "arrowdown"
                                      : "arrowright"
                                  }
                                  className="w-4 h-4"
                                />
                              </button>
                            )}
                            {!product.hasChildren && product.level === 0 && (
                              <div className="w-6 h-6 flex items-center justify-center cursor-not-allowed">
                                {/* <Icon
                                  name="arrowdown"
                                  className="w-4 h-4 text-gray-400"
                                /> */}
                              </div>
                            )}
                            {!product.hasChildren && product.level > 0 && (
                              <div className="w-6 h-6 flex items-center justify-center cursor-not-allowed">
                                {/* <Icon
                                  name="arrowdown"
                                  className="w-4 h-4 text-gray-400"
                                /> */}
                              </div>
                            )}

                            {/* Product name */}
                            {!product.isVariant ? (
                              <div>
                                <div className="font-medium">
                                  {product.productName}
                                </div>
                                <div className="border-b-2 border-black my-1"></div>
                                <div className="text-sm text-gray-500">
                                  {product.hasChildren
                                    ? t("buyXGetYDiscount.values.variantsCount", {
                                        count: productDataTree?.filter(
                                          (p: any) =>
                                            p.isVariant &&
                                            p.parentId === product.productId
                                        ).length,
                                      })
                                    : (() => {
                                        const productType = lookup.getProductType()?.find(
                                          (type: any) => btoa(type?.lookupId) === product?.fkProductTypeLookupValueId
                                        );
                                        return productType ? getLookupDisplayValue(productType, t) : t("buyXGetYDiscount.values.noVariants");
                                      })()}
                                </div>
                              </div>
                            ) : (
                              <span className="text-sm break-words">
                                {product.productName}
                              </span>
                            )}
                          </div>
                        </div>
                      ),
                    },
                    { key: "categoryName", label: t("buyXGetYDiscount.columns.category"), sortable: false },
                    {
                      key: "vendors",
                      label: t("buyXGetYDiscount.columns.vendorPrice"),
                      sortable: false,
                      align: "right" as const,
                      render: (product: any) => (
                        <div className="flex justify-end font-semibold text-right">
                          {getRetailPrices(product.vendors, "costPerUnit")}
                        </div>
                      ),
                    },
                    {
                      key: "prices",
                      sortable: false,
                      label: getPricingMode(cashDiscountConfig) === 'dual-pricing' ? t("buyXGetYDiscount.columns.cardPrice") : t("buyXGetYDiscount.columns.retailPrice"),
                      align: "right" as const,
                      render: (product: any) => (
                        <div className="flex justify-end font-semibold text-right">
                          {getRetailPrices(
                            product.prices,
                            "retailPriceExclTax"
                          )}
                        </div>
                      ),
                    },
                    ...(getPricingMode(cashDiscountConfig) !== 'retail-only' ? [{
                      key: "cashPrices",
                      sortable: false,
                      label: t("buyXGetYDiscount.columns.cashPrice"),
                      align: "right" as const,
                      render: (product: any) => (
                        <div className="text-sm flex justify-end text-right">
                          <div className="font-medium">
                            {getCashPriceDisplay(product.prices, cashDiscountConfig)}
                          </div>
                        </div>
                      ),
                    }] : []),
                    {
                      key: "prices",
                      sortable: false,
                      label: t("buyXGetYDiscount.columns.discountedPrice"),
                      align: "right" as const,
                      render: (product: any) => (
                        <div className="flex justify-end font-semibold">
                          {getRetailPrices(
                            product.prices,
                            "retailPriceExclTax"
                          )}
                        </div>
                      ),
                    },
                    // {
                    //   key: "prices",
                    //   sortable: false,
                    //   label: "Discounted Price",
                    //   render: (product: any) => {
                    //     const originalPrices = getRetailPriceInArray(
                    //       product.prices,
                    //       "retailPriceExclTax"
                    //     );

                    //     if (!originalPrices || originalPrices.length === 0) {
                    //       return <span>$0.00</span>;
                    //     }

                    //     return (
                    //       <>
                    //         {discountType && discountValue > 0 ? (
                    //           <>
                    //             {originalPrices.length === 1 ? (
                    //               <span>
                    //                 $
                    //                 {discountType == 47
                    //                   ? Math.max(
                    //                       originalPrices[0] - discountValue,
                    //                       0
                    //                     ).toFixed(2)
                    //                   : (
                    //                       originalPrices[0] *
                    //                       (1 - discountValue / 100)
                    //                     ).toFixed(2)}
                    //               </span>
                    //             ) : (
                    //               <span>
                    //                 $
                    //                 {discountType == 47
                    //                   ? Math.max(
                    //                       originalPrices[0] - discountValue,
                    //                       0
                    //                     ).toFixed(2)
                    //                   : (
                    //                       originalPrices[0] *
                    //                       (1 - discountValue / 100)
                    //                     ).toFixed(2)}{" "}
                    //                 - $
                    //                 {discountType == 47
                    //                   ? Math.max(
                    //                       originalPrices[1] - discountValue,
                    //                       0
                    //                     ).toFixed(2)
                    //                   : (
                    //                       originalPrices[1] *
                    //                       (1 - discountValue / 100)
                    //                     ).toFixed(2)}
                    //               </span>
                    //             )}
                    //           </>
                    //         ) : (
                    //           <>
                    //             {originalPrices.length === 1 ? (
                    //               <span>${originalPrices[0].toFixed(2)}</span>
                    //             ) : (
                    //               <span>
                    //                 ${originalPrices[0].toFixed(2)} - $
                    //                 {originalPrices[1].toFixed(2)}
                    //               </span>
                    //             )}
                    //           </>
                    //         )}
                    //       </>
                    //     );
                    //   },
                    // },
                    {
                      key: "inventoryLevels",
                      sortable: false,
                      label: t("buyXGetYDiscount.columns.locationQtyInStock"),
                      render: (product: any) => {
                        const inventoryInfo = inventoryData[product.id];

                        if (
                          !inventoryInfo ||
                          inventoryInfo.options.length === 0
                        ) {
                          return (
                            <span className="text-sm text-gray-500">
                              {t("buyXGetYDiscount.values.noStockData")}
                            </span>
                          );
                        }

                        const { options, displayText } = inventoryInfo;

                        // For display-only inventory, use SelectBox with read-only behavior
                        return (
                          <div className="min-w-[150px]">
                            <SelectBox
                              value={options[0] || null} // Set first option as selected value
                              onChange={() => {}} // Prevent changes - read-only behavior
                              options={options}
                              placeholder={displayText}
                              className="!mb-0"
                              size="sm"
                              isClearable={false}
                            />
                          </div>
                        );
                      },
                    },
                    {
                      key: "active",
                      label: t("buyXGetYDiscount.columns.active"),
                      sortable: false,
                      render: (product: any) => (
                        <div className="flex items-center gap-4">
                          <SwitchSlider
                            checked={product.isActive || false}
                            onChange={(checked) =>
                              handleProductSelection(product, checked)
                            }
                            size="sm"
                          />
                          {!product.isVariant && (
                            <button
                              className="p-1 text-red-500 hover:bg-red-50 rounded"
                              type="button"
                              title={t("common.actions.delete")}
                              onClick={() =>
                                confirm({
                                  type: "delete",
                                  title: t("buyXGetYDiscount.deleteConfirm.title"),
                                  message: t("buyXGetYDiscount.deleteConfirm.message", {
                                    name: product.name,
                                  }),
                                  onConfirm: () => confirmDelete(product),
                                })
                              }
                            >
                              <Icon name="delete" className="w-4 h-4" />
                            </button>
                          )}
                        </div>
                      ),
                    },
                  ]}
                />
              </div>

              {/* Get Y section */}
              <div>
                <div className={`border-b border-gray-300 pb-2 mb-6 mt-8 `}>
                  <h2 className="text-lg font-semibold mb-2 text-black">
                    {t("buyXGetYDiscount.sections.customerGets")}
                  </h2>
                  {/* <p className="mb-4 text-sm text-black">
                    Choose When The Promotion Happens
                  </p> */}
                </div>
              </div>
              <div className="flex justify-between items-center w-full">
                <div className="w-full grid grid-cols-1 md:grid-cols-12 gap-6 mb-0">
                  {/* <div className="md:col-span-5">
                    <CommonDropdown
                      control={control}
                      setValue={setValue}
                      label="Select Products Category"
                      name="productCategoryGet"
                      type="categorytreebind"
                      className="!my-0"
                      placeholder="Select Category"
                      // required
                      disabled={categoryDisabled}
                    />
                  </div> */}

                  <div className="md:col-span-6">
                    <Controller
                      name="getProductQuantity"
                      control={control}
                      rules={{
                        required: t("buyXGetYDiscount.validation.productQuantityRequired"),
                        validate: (value) => {
                          const numValue = Number(value);
                          if (isNaN(numValue)) {
                            return t("buyXGetYDiscount.validation.productQuantityInvalid");
                          }
                          if (numValue < 1) {
                            return t("buyXGetYDiscount.validation.productQuantityMin");
                          }
                          return true;
                        },
                      }}
                      render={({ field, fieldState }) => (
                        <DecimalInput
                          value={field.value ?? 0}
                          onChange={field.onChange}
                          fieldType="unit" 
                          max={9999999999}
                          className="!my-0 !mb-6"
                          label={t("buyXGetYDiscount.fields.productQuantity")}
                          placeholder="50"
                          required={true}
                          error={fieldState.error?.message}
                        />
                      )}
                    />
                  </div>
                  <div className="md:col-span-2"></div>
                  <div className="flex justify-end items-center gap-2 md:col-span-4">
                    <Button
                      type="button"
                      theme="secondary"
                      onClick={() => {
                        const selectedLocations = getValues("locations");
                        if (!selectedLocations || selectedLocations.length === 0) {
                          toast.error(t("buyXGetYDiscount.validation.selectLocationFirst"));
                          return;
                        }
                        setShowSelectAllModalForGet(true);
                      }}
                    >
                      {t("buyXGetYDiscount.buttons.selectAllProducts")}
                    </Button>
                    <Button
                      type="button"
                      onClick={() => {
                        const selectedLocations = getValues("locations");
                        if (!selectedLocations || selectedLocations.length === 0) {
                          toast.error(t("buyXGetYDiscount.validation.selectLocationFirst"));
                          return;
                        }
                        setShowAddDiscountModalForGet(true);
                      }}
                    >
                      {t("buyXGetYDiscount.buttons.searchProduct")}
                    </Button>
                  </div>
                </div>

                {showAddDiscountModalForGet && (
                  <SiteModal
                    modalWidth={1000}
                    width={true}
                    // className="mt-20"
                    isOpen={showAddDiscountModalForGet}
                    onClose={closeAddDiscountModalForGet}
                    title={t("buyXGetYDiscount.modal.selectProductsTitle")}
                    isBlur={true}
                    closeOnBackdrop={false}
                  >
                    <ProductSearchModal
                      // category={getValues(`productCategoryGet`) ? [getValues(`productCategoryGet`)] : []}
                      category={[]}
                      onClose={closeAddDiscountModalForGet}
                      onConfirm={searchConfirmGet}
                      productData={productDataGet}
                      disableCategory={false}
                      defaultStatus="active"
                      location={getValues("locations") || []}
                    ></ProductSearchModal>
                  </SiteModal>
                )}

                {showSelectAllModalForGet && (
                  <SiteModal
                    modalWidth={1000}
                    width={true}
                    isOpen={showSelectAllModalForGet}
                    onClose={closeSelectAllModalForGet}
                    title={t("buyXGetYDiscount.modal.selectProductsTitle")}
                    isBlur={true}
                    closeOnBackdrop={false}
                  >
                    <ProductSearchModalAll
                      category={[]}
                      onClose={closeSelectAllModalForGet}
                      onConfirm={(selected: any) => {
                        searchConfirmGet(selected);
                        setShowSelectAllModalForGet(false);
                      }}
                      productData={productDataGet}
                      disableCategory={false}
                      defaultStatus="active"
                      location={getValues("locations") || []}
                    ></ProductSearchModalAll>
                  </SiteModal>
                )}
              </div>
              <div className="mt-6">
                <ReusableTable
                  fixedHeight="calc(100vh - 200px)"
                  paddingBottomNeeded={productDataTreeGet?.length > 0}
                  data={getVisibleProductsGet()}
                  enableExpand={false}
                  columns={[
                    {
                      key: "productName",
                      label: t("buyXGetYDiscount.columns.productName"),
                      sortable: false,
                      render: (product: any) => (
                        <div className="flex items-center gap-2">
                          {/* Indentation for tree structure */}
                          <div
                            style={{ marginLeft: product.level * 20 }}
                            className="flex items-center gap-2"
                          >
                            {/* Expand/Collapse button for products with variants */}
                            {product.hasChildren && (
                              <button
                                type="button"
                                onClick={() =>
                                  handleToggleExpand(product.productId)
                                }
                                className="w-6 h-6 flex cursor-pointer items-center justify-center text-gray-600 hover:text-gray-800 hover:bg-gray-100 rounded transition-colors"
                              >
                                <Icon
                                  name={
                                    expandedProducts.has(product.productId)
                                      ? "arrowdown"
                                      : "arrowright"
                                  }
                                  className="w-4 h-4"
                                />
                              </button>
                            )}
                            {!product.hasChildren && product.level === 0 && (
                              <div className="w-6 h-6 flex items-center justify-center cursor-not-allowed">
                                {/* <Icon
                                  name="arrowdown"
                                  className="w-4 h-4 text-gray-400"
                                /> */}
                              </div>
                            )}
                            {!product.hasChildren && product.level > 0 && (
                              <div className="w-6 h-6 flex items-center justify-center cursor-not-allowed">
                                {/* <Icon
                                  name="arrowdown"
                                  className="w-4 h-4 text-gray-400"
                                /> */}
                              </div>
                            )}

                            {/* Product name */}
                            {!product.isVariant ? (
                              <div>
                                <div className="font-medium">
                                  {product.productName}
                                </div>
                                <div className="border-b-2 border-black my-1"></div>
                                <div className="text-sm text-gray-500">
                                  {product.hasChildren
                                    ? t("buyXGetYDiscount.values.variantsCount", {
                                        count: productDataTreeGet?.filter(
                                          (p: any) =>
                                            p.isVariant &&
                                            p.parentId === product.productId
                                        ).length,
                                      })
                                    : (() => {
                                        const productType = lookup.getProductType()?.find(
                                          (type: any) => btoa(type?.lookupId) === product?.fkProductTypeLookupValueId
                                        );
                                        return productType ? getLookupDisplayValue(productType, t) : t("buyXGetYDiscount.values.noVariants");
                                      })()}
                                </div>
                              </div>
                            ) : (
                              <span className="text-sm break-words">
                                {product.productName}
                              </span>
                            )}
                          </div>
                        </div>
                      ),
                    },
                    { key: "categoryName", label: t("buyXGetYDiscount.columns.category"), sortable: false },
                    {
                      key: "vendors",
                      label: t("buyXGetYDiscount.columns.vendorPrice"),
                      sortable: false,
                      align: "right" as const,
                      render: (product: any) => (
                        <div className="flex justify-end font-semibold text-right">
                        {getRetailPrices(product.vendors, "costPerUnit")}
                        </div>
                      ),
                    },
                    {
                      key: "prices",
                      sortable: false,
                      label: getPricingMode(cashDiscountConfig) === 'dual-pricing' ? t("buyXGetYDiscount.columns.cardPrice") : t("buyXGetYDiscount.columns.retailPrice"),
                      align: "right" as const,
                      render: (product: any) => (
                        <div className="flex justify-end font-semibold text-right">
                          {getRetailPrices(
                            product.prices,
                            "retailPriceExclTax"
                          )}
                        </div>
                      ),
                    },
                    ...(getPricingMode(cashDiscountConfig) !== 'retail-only' ? [{
                      key: "cashPrices",
                      sortable: false,
                      label: t("buyXGetYDiscount.columns.cashPrice"),
                      align: "right" as const,
                      render: (product: any) => (
                        <div className="text-sm flex justify-end text-right">
                          <div className="font-medium">
                            {getCashPriceDisplay(product.prices, cashDiscountConfig)}
                          </div>
                        </div>
                      ),
                    }] : []),
                    {
                      key: "prices",
                      sortable: false,
                      label: t("buyXGetYDiscount.columns.discountedPrice"),
                      align: "right" as const,
                      render: (product: any) => {
                        const originalPrices = getRetailPriceInArray(
                          product.prices,
                          "retailPriceExclTax"
                        );

                        if (!originalPrices || originalPrices.length === 0) {
                          return <div className="flex justify-end font-semibold text-right"><span>$0.00</span></div>;
                        }

                        return (
                          <div className="flex justify-end font-semibold text-right">
                            {discountType && discountValue > 0 ? (
                              <>
                                {originalPrices.length === 1 ? (
                                  <span>
                                    $
                                    {discountType == 47
                                      ? formatCurrency(Math.max(
                                          originalPrices[0] - discountValue,
                                          0
                                        ))
                                      : formatCurrency(
                                          originalPrices[0] *
                                          (1 - discountValue / 100)
                                        )}
                                  </span>
                                ) : (
                                  <span>
                                    $
                                    {discountType == 47
                                      ? formatCurrency(Math.max(
                                          originalPrices[0] - discountValue,
                                          0
                                        ))
                                      : formatCurrency(
                                          originalPrices[0] *
                                          (1 - discountValue / 100)
                                        )}{" "}
                                    - $
                                    {discountType == 47
                                      ? formatCurrency(Math.max(
                                          originalPrices[1] - discountValue,
                                          0
                                        ))
                                      : formatCurrency(
                                          originalPrices[1] *
                                          (1 - discountValue / 100)
                                        )}
                                  </span>
                                )}
                              </>
                            ) : (
                              <>
                                {originalPrices.length === 1 ? (
                                  <span>${formatCurrency(originalPrices[0])}</span>
                                ) : (
                                  <span>
                                    ${formatCurrency(originalPrices[0])} - $
                                    {formatCurrency(originalPrices[1])}
                                  </span>
                                )}
                              </>
                            )}
                          </div>
                        );
                      },
                    },
                    {
                      key: "inventoryLevels",
                      sortable: false,
                      label: t("buyXGetYDiscount.columns.locationQtyInStock"),
                      render: (product: any) => {
                        const inventoryInfo = inventoryDataGet[product.id];

                        if (
                          !inventoryInfo ||
                          inventoryInfo.options.length === 0
                        ) {
                          return (
                            <span className="text-sm text-gray-500">
                              {t("buyXGetYDiscount.values.noStockData")}
                            </span>
                          );
                        }

                        const { options, displayText } = inventoryInfo;

                        // For display-only inventory, use SelectBox with read-only behavior
                        return (
                          <div className="min-w-[150px]">
                            <SelectBox
                              value={options[0] || null} // Set first option as selected value
                              onChange={() => {}} // Prevent changes - read-only behavior
                              options={options}
                              placeholder={displayText}
                              className="!mb-0"
                              size="sm"
                              isClearable={false}
                            />
                          </div>
                        );
                      },
                    },
                    {
                      key: "active",
                      label: t("buyXGetYDiscount.columns.active"),
                      sortable: false,
                      render: (product: any) => (
                        <div className="flex items-center gap-4">
                          <SwitchSlider
                            checked={product.isActive || false}
                            onChange={(checked) =>
                              handleProductSelectionGet(product, checked)
                            }
                            size="sm"
                          />
                          {!product.isVariant && (
                            <button
                              className="p-1 text-red-500 hover:bg-red-50 rounded"
                              type="button"
                              title={t("common.actions.delete")}
                              onClick={() =>
                                confirm({
                                  type: "delete",
                                  title: t("buyXGetYDiscount.deleteConfirm.title"),
                                  message: t("buyXGetYDiscount.deleteConfirm.message", {
                                    name: product.name,
                                  }),
                                  onConfirm: () => confirmDeleteGet(product),
                                })
                              }
                            >
                              <Icon name="delete" className="w-4 h-4" />
                            </button>
                          )}
                        </div>
                      ),
                    },
                  ]}
                />
              </div>

              {/* Discount Rule Section */}
              <div className="mt-8">
                <div className={`border-b border-gray-300 pb-2 mb-6 `}>
                  <h2 className="text-lg font-semibold mb-2 text-black">
                    {t("buyXGetYDiscount.sections.atDiscountValue")}
                  </h2>
                  <p className="mb-4 text-sm text-black">
                    {t("buyXGetYDiscount.sections.atDiscountValueSubtitle")}
                  </p>
                </div>
                <div className="grid grid-cols-1 md:grid-cols-2 gap-6 mb-0">
                  <CommonDropdown
                    preSelectValues={
                      discount &&
                      discount.rules &&
                      Array.isArray(discount.rules) &&
                      discount.rules[0] &&
                      discount.rules[0].fkDiscountValueTypeLookupValueId
                        ? atob(
                            discount.rules[0].fkDiscountValueTypeLookupValueId
                          )
                        : '48'
                    }
                    control={control}
                    setValue={setValue}
                    label={t("buyXGetYDiscount.fields.discountType")}
                    name="rules.0.fkDiscountValueTypeLookupValueId"
                    type="lookup"
                    placeholder={t("buyXGetYDiscount.placeholders.selectDiscountType")}
                    required
                    rules={{ required: t("buyXGetYDiscount.validation.discountTypeRequired")}}
                    data={lookup.getDiscountType()}
                  />
                  <Controller
                    name="rules.0.discountValue"
                    control={control}
                    rules={{ required: t("buyXGetYDiscount.validation.discountValueRequired") ,
                      validate: (value) => {
                          const numValue = Number(value);
                          const discountTypeValue = discountType; // This is from watch()

                          // Check if it's a valid number
                          if (isNaN(numValue)) {
                            return t("buyXGetYDiscount.validation.discountValueInvalid");
                          }

                          // Fixed amount discount (assuming ID 47 is fixed amount)
                          if (discountTypeValue == 47) {
                            if (numValue < 0) {
                              return t("buyXGetYDiscount.validation.fixedDiscountMin");
                            }
                            if (numValue > 1000) {
                              return t("buyXGetYDiscount.validation.fixedDiscountMax");
                            }
                          }
                          // Percentage discount (assuming other IDs are percentage)
                          else {
                            if (numValue < 0) {
                              return t("buyXGetYDiscount.validation.percentDiscountMin");
                            }
                            if (numValue > 100) {
                              return t("buyXGetYDiscount.validation.percentDiscountMax");
                            }
                          }

                          return true;
                        },
                    }}
                    render={({ field, fieldState }) => (
                      <DecimalInput
                        value={field.value}
                        onChange={field.onChange}
                        decimalPlaces={2}
                        min={0}
                        max={discountType == 47 ? 9999999999 : 100}
                        className="!my-0 !mb-6"
                        label={t("buyXGetYDiscount.fields.discountValue")}
                        placeholder="0"
                        required
                        withDollarIcon={discountType == 47}
                        error={fieldState.error?.message as any}
                      />
                    )}
                  />
                </div>
              </div>

              {/* Discount Schedule */}
              <div className="mt-6">
                <div className={`border-b border-gray-300 pb-2 mb-6`}>
                  <h2 className="text-lg font-semibold mb-2 text-black">
                    {t("buyXGetYDiscount.sections.discountSchedule")}
                  </h2>
                  <p className="mb-4 text-sm text-black"></p>
                </div>

                {/* Date Range */}
                <div>
                  <div className="flex items-center gap-6 mb-6">
                    <div className="flex items-center gap-2">
                      <label className="relative inline-flex items-center cursor-pointer">
                        <input
                          type="checkbox"
                          className="sr-only peer hidden"
                          {...control.register("isSetDateRange")}
                        />
                        <div className="w-11 h-6 bg-tertiary relative peer-focus:outline-none after:content-[''] after:top-1 after:absolute after:block after:w-4 after:h-4 after:bg-white after:rounded-full after:left-1 peer-focus:ring-blue-500 rounded-full peer peer-checked:bg-secondary peer-checked:after:right-1 peer-checked:after:left-auto  transition-all"></div>
                        <span className="ml-2 text-sm font-semibold text-black">
                          {t("buyXGetYDiscount.toggles.setDateRange")}
                        </span>
                      </label>
                    </div>
                  </div>
                  <div
                    className={`relative mb-6 ${
                      !isSetDateRangeWatch
                        ? `after:content-[''] after:left-0 after:right-0 after:top-0 after:bottom-0 after:absolute after:block after:h-full after:w-full after:bg-white after:bg-opacity-50`
                        : ``
                    }`}
                  >
                    <div className="border border-gray-300 bg-white p-1.5 rounded-md overflow-hidden">
                      <div className="grid grid-cols-2 bg-[#e3e4e9] text-black text-sm font-medium">
                        <div className="px-2.5 py-4 border-r border-gray-100">
                          {t("buyXGetYDiscount.schedule.period")}
                        </div>
                        <div className="px-2.5 py-4">{t("buyXGetYDiscount.schedule.date")}</div>
                      </div>
                      <div className="grid grid-cols-2 border-t border-white">
                        <div className="px-2.5 py-2 border-r bg-[#e3e4e9] border-gray-300 flex items-center w-full text-sm font-normal text-black">
                          {t("buyXGetYDiscount.schedule.start")}
                        </div>
                        <div className="px-2.5 py-2">
                          <Controller
                            name="dateRanges.0.startDate"
                            control={control}
                            disabled={!isSetDateRangeWatch}
                            render={({ field }) => (
                              <div className="flex items-center">
                                <div className="w-full grow">
                                  <DatePicker
                                    selected={field.value}
                                    onChange={(date) => {
                                      field.onChange(date);
                                      if (
                                        scheduleenddateWatch &&
                                        moment(date).isAfter(
                                          moment(scheduleenddateWatch)
                                        )
                                      ) {
                                        setValue(`dateRanges.0.endDate`, null);
                                      }
                                    }}
                                    showYearDropdown
                                    dropdownMode="select"
                                    showMonthDropdown
                                    icon={<Icon name="calendar" />}
                                    showIcon
                                    toggleCalendarOnIconClick
                                    placeholderText="MM/DD/YYYY"
                                    className="w-full border border-gray-300 rounded-md !pl-3 !pr-8 !py-2 focus:outline-none focus:ring-2 focus:ring-blue-500"
                                    wrapperClassName="w-full"
                                    calendarIconClassName={`right-0 text-gray-400 top-1`}
                                    dateFormat="MM/dd/YYYY"
                                    disabled={!isSetDateRangeWatch}
                                    minDate={moment().toDate()}
                                  />
                                </div>
                              </div>
                            )}
                          />
                        </div>
                      </div>
                      <div className="grid grid-cols-2 border-t border-white">
                        <div className="px-2.5 py-2 border-r bg-[#e3e4e9] border-gray-300 flex items-center w-full text-sm font-normal text-black">
                          {t("buyXGetYDiscount.schedule.end")}
                        </div>
                        <div className="px-2.5 py-2">
                          <Controller
                            name="dateRanges.0.endDate"
                            control={control}
                            disabled={!isSetDateRangeWatch}
                            render={({ field }) => (
                              <div className="flex items-center">
                                <div className="w-full grow">
                                  <DatePicker
                                    selected={field.value}
                                    onChange={(date) => field.onChange(date)}
                                    showIcon
                                    showYearDropdown
                                    dropdownMode="select"
                                    showMonthDropdown
                                    icon={<Icon name="calendar" />}
                                    toggleCalendarOnIconClick
                                    placeholderText="MM/DD/YYYY"
                                    className="w-full border border-gray-300 rounded-md !pl-3 !pr-8 !py-2 focus:outline-none focus:ring-2 focus:ring-blue-500"
                                    wrapperClassName="w-full"
                                    calendarIconClassName={`right-0 text-gray-400 top-1`}
                                    dateFormat="MM/dd/YYYY"
                                    disabled={!isSetDateRangeWatch}
                                    minDate={
                                      schedulestartdateWatch &&
                                      typeof schedulestartdateWatch !==
                                        `undefined` &&
                                      schedulestartdateWatch
                                        ? moment(
                                            schedulestartdateWatch
                                          ).toDate()
                                        : moment().toDate()
                                    }
                                  />
                                </div>
                              </div>
                            )}
                          />
                        </div>
                      </div>
                    </div>
                  </div>
                </div>

                {/* Weekly Schedule */}
                <div>
                  <div className="flex items-center gap-6 mb-6">
                    <div className="flex items-center gap-2">
                      <label className="relative inline-flex items-center cursor-pointer">
                        <input
                          type="checkbox"
                          className="sr-only peer hidden"
                          {...control.register("isSetSchedule")}
                        />
                        <div className="w-11 h-6 bg-tertiary relative peer-focus:outline-none after:content-[''] after:top-1 after:absolute after:block after:w-4 after:h-4 after:bg-white after:rounded-full after:left-1 peer-focus:ring-blue-500 rounded-full peer peer-checked:bg-secondary peer-checked:after:right-1 peer-checked:after:left-auto  transition-all"></div>
                        <span className="ml-2 text-sm font-semibold text-black">
                          {t("buyXGetYDiscount.toggles.setSchedule")}
                        </span>
                      </label>
                    </div>
                  </div>
                  <div
                    className={`relative mb-6 ${
                      !isSetScheduleWatch
                        ? `after:content-[''] after:left-0 after:right-0 after:top-0 after:bottom-0 after:absolute after:block after:h-full after:w-full after:bg-white after:bg-opacity-50`
                        : ``
                    }`}
                  >
                    <div className="border border-gray-300 bg-white p-1.5 rounded-md overflow-hidden">
                      <div className="flex items-center bg-[#e3e4e9] text-black text-sm font-medium">
                        <div className="px-2.5 py-4 border-r border-gray-100 w-20"></div>
                        <div className="grid grid-cols-3 w-full">
                          <div className="px-2.5 py-4 border-r border-gray-100">
                            {t("buyXGetYDiscount.schedule.days")}
                          </div>
                          <div className="px-2.5 py-4 border-r border-gray-100">
                            {t("buyXGetYDiscount.schedule.startTime")}
                          </div>
                          <div className="px-2.5 py-4">{t("buyXGetYDiscount.schedule.endTime")}</div>
                        </div>
                      </div>
                      {weeklySchedulesWatch.map(
                        (wkschedule: any, index: number) => {
                          return (
                            <div
                              className="flex items-center border-t border-white"
                              key={`wk-` + index}
                            >
                              <label className="px-2.5 py-2 w-20 bg-white border-r border-gray-300 flex justify-center items-center">
                                <input
                                  type="checkbox"
                                  disabled={!isSetScheduleWatch}
                                  {...control.register(
                                    `weeklySchedules.${index}.isActive`
                                  )}
                                />
                              </label>
                              <div className="grid grid-cols-3 w-full">
                                <div className="px-2.5 py-2 border-r bg-[#e3e4e9] border-gray-300 flex items-center w-full text-sm font-normal text-black">
                                  {(dayNameObj as any)[wkschedule.dayOfWeek]}
                                  {wkschedule.isActive && (
                                    <span className="text-red-600 ml-1">*</span>
                                  )}
                                </div>
                                <div className="px-2.5 py-2">
                                  <Controller
                                    name={`weeklySchedules.${index}.startTime`}
                                    control={control}
                                    disabled={
                                      !isSetScheduleWatch ||
                                      !wkschedule.isActive
                                    }
                                    rules={
                                      wkschedule.isActive
                                        ? { required: t("buyXGetYDiscount.validation.startTimeRequired") }
                                        : {}
                                    }
                                    render={({ field }) => (
                                      <div className="flex items-center">
                                        <div className="w-full grow">
                                          <DatePicker
                                            selected={field.value}
                                            onChange={(date) => {
                                              field.onChange(date);
                                              if (
                                                wkschedule.endTime &&
                                                date &&
                                                moment(date).isSameOrAfter(
                                                  moment(wkschedule.endTime)
                                                )
                                              ) {
                                                const startMoment = moment(date);
                                                const maxEndTime = moment(moment().format(`YYYY-MM-DD 23:55:00`));
                                                let newEndTime = startMoment.clone().add(5, `minutes`);
                                                
                                                // Cap end time at 11:55 PM
                                                if (newEndTime.isAfter(maxEndTime)) {
                                                  newEndTime = maxEndTime;
                                                }
                                                
                                                setValue(
                                                  `weeklySchedules.${index}.endTime`,
                                                  newEndTime.toDate()
                                                );
                                              }
                                            }}
                                            icon={<Icon name="clock" />}
                                            showIcon
                                            toggleCalendarOnIconClick
                                            placeholderText="HH:MM"
                                            className="w-full border border-gray-300 rounded-md !pl-3 !pr-8 !py-2 focus:outline-none focus:ring-2 focus:ring-blue-500"
                                            wrapperClassName="w-full"
                                            calendarIconClassName={`right-0 text-gray-400 top-1`}
                                            showTimeSelect
                                            showTimeSelectOnly
                                            timeIntervals={5}
                                            dateFormat="hh:mm aaaa"
                                            showTimeCaption={true}
                                            disabled={
                                              !isSetScheduleWatch ||
                                              !wkschedule.isActive
                                            }
                                            minTime={moment(
                                              moment().format(
                                                `YYYY-MM-DD 00:00:00`
                                              )
                                            ).toDate()}
                                            maxTime={moment(
                                              moment().format(
                                                `YYYY-MM-DD 23:50:00`
                                              )
                                            ).toDate()}
                                            required={wkschedule.isActive}
                                          />
                                        </div>
                                      </div>
                                    )}
                                  />
                                </div>
                                <div className="px-2.5 py-2">
                                  <Controller
                                    name={`weeklySchedules.${index}.endTime`}
                                    control={control}
                                    disabled={
                                      !isSetScheduleWatch ||
                                      !wkschedule.isActive
                                    }
                                    rules={
                                      wkschedule.isActive
                                        ? { required: t("buyXGetYDiscount.validation.startTimeRequired") }
                                        : {}
                                    }
                                    render={({ field }) => (
                                      <div className="flex items-center">
                                        <div className="w-full grow">
                                          <DatePicker
                                            selected={field.value}
                                            onChange={(date) =>
                                              field.onChange(date)
                                            }
                                            icon={<Icon name="clock" />}
                                            showIcon
                                            toggleCalendarOnIconClick
                                            placeholderText="HH:MM"
                                            className="w-full border border-gray-300 rounded-md !pl-3 !pr-8 !py-2 focus:outline-none focus:ring-2 focus:ring-blue-500"
                                            wrapperClassName="w-full"
                                            calendarIconClassName={`right-0 text-gray-400 top-1`}
                                            showTimeSelect
                                            showTimeSelectOnly
                                            timeIntervals={5}
                                            dateFormat="hh:mm aaaa"
                                            showTimeCaption={true}
                                            disabled={
                                              !isSetScheduleWatch ||
                                              !wkschedule.isActive
                                            }
                                            minTime={
                                              wkschedule.startTime &&
                                              typeof wkschedule.startTime !==
                                                `undefined` &&
                                              wkschedule.startTime
                                                ? (() => {
                                                    const minTime = moment(wkschedule.startTime).add(5, `minutes`);
                                                    const maxTime = moment(moment().format(`YYYY-MM-DD 23:55:00`));
                                                    // If adding 5 minutes goes past 23:55, cap it at 23:55
                                                    return minTime.isAfter(maxTime) ? maxTime.toDate() : minTime.toDate();
                                                  })()
                                                : moment(
                                                    moment().format(
                                                      `YYYY-MM-DD 00:00:00`
                                                    )
                                                  ).toDate()
                                            }
                                            maxTime={moment(
                                              moment().format(
                                                `YYYY-MM-DD 23:55:00`
                                              )
                                            ).toDate()}
                                            required={wkschedule.isActive}
                                          />
                                        </div>
                                      </div>
                                    )}
                                  />
                                </div>
                              </div>
                            </div>
                          );
                        }
                      )}
                    </div>
                  </div>
                </div>
              </div>

              {/* Discount Target */}
              <div className="mt-8">
                <div className={`border-b border-gray-300 pb-2 mb-6 `}>
                  <h2 className="text-lg font-semibold mb-2 text-black">
                    {t("buyXGetYDiscount.sections.discountTarget")}
                  </h2>
                  <p className="mb-4 text-sm text-black">
                    {t("buyXGetYDiscount.sections.discountTargetSubtitle")}
                  </p>
                </div>
                <div className="grid grid-cols-2 gap-1 mb-6">
                  <label>
                    <input
                      type="radio"
                      className="hidden sr-only peer"
                      value={btoa(`139`)}
                      {...control.register("fkCustomerTargetTypeLookupValueId")}
                    />
                    <span
                      className={`text-center cursor-pointer block bg-white px-5 py-5 border border-gray-50 rounded peer-checked:border-blue-500`}
                    >
                      {t("buyXGetYDiscount.target.allCustomers")}
                    </span>
                  </label>
                  <label>
                    <input
                      type="radio"
                      className="hidden sr-only peer"
                      value={btoa(`140`)}
                      {...control.register("fkCustomerTargetTypeLookupValueId")}
                    />
                    <span
                      className={`text-center cursor-pointer block bg-white px-5 py-5 border border-gray-50 rounded peer-checked:border-blue-500`}
                    >
                      {t("buyXGetYDiscount.target.specificGroups")}
                    </span>
                  </label>
                </div>

                {/* Customer Groups Dropdown - Only show when specific customer groups is selected */}
                {fkCustomerTargetTypeLookupValueIdWatch === btoa(`140`) && (
                  <div className="mb-6">
                    <CommonDropdown
                      control={control}
                      setValue={setValue}
                      preSelectValues={
                        discount &&
                        discount.customerGroups &&
                        Array.isArray(discount.customerGroups)
                          ? discount.customerGroups.map(
                              (cg: any) => cg.fkCustomerGroupId
                            )
                          : null
                      }
                      rules={{
                        required: t("buyXGetYDiscount.validation.customerGroupsRequired"),
                      }}
                      label={t("buyXGetYDiscount.fields.customerGroups")}
                      name="customerGroups"
                      type="allCustomerGroups"
                      placeholder={t("buyXGetYDiscount.placeholders.selectCustomerGroups")}
                      required={true}
                      isMulti={true}
                    />
                  </div>
                )}
              </div>
            </div>
          </form>
        </div>
      </Container>
    </div>
  );
};

export default BuyXGetYDiscount;
